/* eslint-disable no-undefined */
import React, {useCallback} from 'react';
import {useStoreActions, useStoreState} from "easy-peasy";
import {withTransition, loadRemainingAnimations, playQ1Animation, playQ2Animation, playQ3Animation} from "../utils/animation";

const MultipleChoiceButton = props => {
    const goto                = useStoreActions(actions => actions.path.goto);
    const setNextQuestionId   = useStoreActions(actions => actions.question.setCurrentId);
    const updateAnswers       = useStoreActions(actions => actions.answers.update);
    const setCurrentAnimation = useStoreActions(actions => actions.animation.setCurrent);
    const answers             = useStoreState(state => state.answers.current);

    const onClick = useCallback(() => {
        let animPromise;

        const getDataLayerArgument = (firstAnswer, currentAnswer) => firstAnswer ? `${firstAnswer}_${currentAnswer}` : currentAnswer;
        window.dataLayer.push(getDataLayerArgument(answers[0], props.result));

        if (props.questionIndex === 1) {
            const updatedAnswers = answers;
            updatedAnswers[0]    = props.result;
            updateAnswers(updatedAnswers);
            playQ1Animation(setCurrentAnimation, props.result);
            animPromise = loadRemainingAnimations(props.result)
                .catch(console.error);
        } else if (props.questionIndex === 2) {
            const updatedAnswers = answers;
            updatedAnswers[1]    = props.result;
            updateAnswers(updatedAnswers);
            playQ2Animation(setCurrentAnimation, answers[0]);
        } else if (props.questionIndex === 3) {
            const updatedAnswers = answers;
            updatedAnswers[2]    = props.result;
            updateAnswers(updatedAnswers);
            playQ3Animation(setCurrentAnimation, answers[0]);
        }
        // family, empty_nester, retirement, disability
        withTransition({
            targets  : `.quiz-container`,
            opacity  : 0,
            duration : 600,
            easing   : `linear`,
            complete : () => {
                if (props.questionIndex < 4) {
                    if (animPromise) {
                        animPromise.then(() => {
                            goto(`/q${props.questionIndex + 1}`);
                            setNextQuestionId(props.nextQuestion);
                        });
                    } else {
                        goto(`/q${props.questionIndex + 1}`);
                        setNextQuestionId(props.nextQuestion);
                    }
                }
            }
        });
    }, [
        goto,
        updateAnswers,
        props.result,
        props.questionIndex,
        props.nextQuestion,
        setNextQuestionId,
        setCurrentAnimation,
        answers
    ]);

    return (
        <button className={`option q${props.questionIndex}-button`} onClick={onClick} aria-controls="App">
            {props.answer}
        </button>
    );
};

export default MultipleChoiceButton;
